var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.04 17.04"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.94 16.24-6.6-6.6a.77.77 0 0 1-.1-1 5.5 5.5 0 0 0 .8-4.2 5.58 5.58 0 1 0-2.4 5.8.92.92 0 0 1 1 .1l6.6 6.6c.1.1.2.1.4.1s.3 0 .4-.1a2 2 0 0 0-.1-.7M1.04 5.64a4.5 4.5 0 1 1 4.5 4.5 4.48 4.48 0 0 1-4.5-4.5"
  })));
};
export default SvgSearch;